module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jascc-bc3ab7f640fb51514017c8db81b40709.svg";